import decode from 'jwt-decode';
import { LOGIN, LOGOUT, FIRST_AUTH_DATA } from './types';
import SocketConnect from '../../../utils/socket';
import sessionStorageHelper from '../../../utils/sessionStorageHelper';

export default {
  [LOGIN]: (state, payload) => {
    if (payload) {
      const accessToken = payload.access;
      const refreshToken = payload.refresh;
      state.isLoggedIn = !!accessToken;
      state.access = accessToken;
      state.refresh = refreshToken;
      state.customerId = decode(payload.access).customer_id;
      const socket = new SocketConnect();
      socket.connect(true);
    }
  },
  [LOGOUT]: (state) => {
    state.isLoggedIn = false;
    state.access = null;
    state.refresh = null;
    state.customerId = null;
    state.userFirstAuth = {};
    sessionStorageHelper.removeItem('userFirstAuth');
    const socket = new SocketConnect();

    socket.disconnect(true);
  },
  [FIRST_AUTH_DATA]: (state, payload) => {
    state.userFirstAuth = payload.data || {};
    if (payload.data && Object.keys(payload.data).length) {
      sessionStorageHelper.setItem('userFirstAuth', payload.data);
    } else {
      sessionStorageHelper.removeItem('userFirstAuth');
    }
  },
};
